 
import { Command, CommandInput } from '@/components/ui/command'
import { Card } from '@/components/ui/card'

interface SavedSearchProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  onClearSearch: () => void
}

 

export function SavedSearch({ searchQuery, onSearchChange }: SavedSearchProps) {
  return (
    <div className="max-w-md">
      <Card className="p-0">
        <Command className="border-0">
          <CommandInput
            placeholder="Search analyzed accounts..."
            value={searchQuery}
            onValueChange={onSearchChange}
            className="border-0"
          />
        </Command>
      </Card>
    </div>
  )
} 